<template>
  <fullscreen-dialog
    v-model="model"
    :title="$t('join_restoran')"
    :subtitle="firm?.name ? firm.name + ' | ID: ' + firm.id : ''"
    icon="mdi-cog-outline"
    @close="close"
    @save="save"
  >
    <template #filters>
      <v-row class="px-3 py-2">
        <v-col cols="12" md="4" class="mb-0 pb-0">
          <autocomplete
            @change="onCountryChange"
            v-model="editedItem.country"
            :items="countries"
            :label="$t('country')"
            required
            item-text="name"
            item-id="id"
            return-object
          />
        </v-col>
        <v-col cols="12" md="4" class="mb-0 pb-0">
          <autocomplete
            v-model="editedItem.city"
            @change="onCityChange"
            :items="cities ? cities : []"
            :label="$t('city')"
            required
            item-text="name"
            item-id="id"
            return-object
          />
        </v-col>
        <v-col cols="12" md="4" class="mb-0 pb-0">
          <text-field
            v-model="searchRes"
            append-icon="mdi-magnify"
            :label="$t('search')"
            hide-details
          />
        </v-col>
      </v-row>
    </template>

    <h3 class="px-8 mb-4 text-center" v-if="restaurants && restaurants.length">
      {{ $t("restaurants") }}
    </h3>
    <v-data-table
      dense
      :headers="headersRes"
      class="ordera-box-shadow"
      :items="restaurants || []"
      :search="searchRes"
    >
      <template v-slot:item.check="{ item }">
        <label :for="`check-${item.id}`">
          <input
            v-if="
              item.restoran_delivery_company.length &&
              item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
                .restaurant_id
            "
            @change="onSelectRestaurant(item)"
            :id="`check-${item.id}`"
            style="cursor: pointer"
            :value="item.id"
            v-model="
              item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
                .restaurant_id
            "
            type="checkbox"
          />
          <input
            v-else
            @change="onSelectRestaurant(item)"
            :id="`check-${item.id}`"
            style="cursor: pointer"
            :true-value="item.id"
            v-model="item.restaurant_id"
            type="checkbox"
          />
        </label>
      </template>
      <template v-slot:item.active_restoran="{ item }">
        <label
          v-if="
            item.restoran_delivery_company.length &&
            item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
              .restaurant_id
          "
          :for="`active-restoran-${item.id}`"
        >
          <input
            :id="`active-restoran-${item.id}`"
            style="cursor: pointer"
            :value="item"
            v-model="
              item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
                .active_restoran
            "
            type="checkbox"
          />
        </label>
        <label v-else :for="`active-restoran-${item.id}`">
          <input
            :id="`active-restoran-${item.id}`"
            style="cursor: pointer"
            :value="item"
            v-model="item.active_restoran"
            type="checkbox"
          />
        </label>
      </template>
      <template v-slot:item.active_company="{ item }">
        <label
          v-if="
            item.restoran_delivery_company.length &&
            item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
              .restaurant_id
          "
          :for="`active-company-${item.id}`"
        >
          <input
            :id="`active-company-${item.id}`"
            style="cursor: pointer"
            :value="item.id"
            v-model="
              item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
                .active_company
            "
            type="checkbox"
          />
        </label>
        <label v-else :for="`active-company-${item.id}`">
          <input
            :id="`active-company-${item.id}`"
            style="cursor: pointer"
            :value="item.id"
            v-model="item.active_company"
            type="checkbox"
          />
        </label>
      </template>
      <template v-slot:item.paying_type="{ item }">
        <autocomplete
          v-if="
            item.restoran_delivery_company.length &&
            item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
              .restaurant_id
          "
          v-model="
            item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
              .paying_type
          "
          :items="[
            { name: $t('choose'), val: 0 },
            { name: $t('by_month'), val: 1 },
            { name: $t('by_percent'), val: 2 },
            { name: $t('by_meal'), val: 3 },
          ]"
          item-text="name"
          item-value="val"
        />

        <autocomplete
          v-else
          v-model="item.paying_type"
          :items="[
            { name: $t('choose'), val: 0 },
            { name: $t('by_month'), val: 1 },
            { name: $t('by_percent'), val: 2 },
            { name: $t('by_meal'), val: 3 },
          ]"
          item-text="name"
          item-value="val"
        />
      </template>
      <template v-slot:item.paying="{ item }">
        <text-field
          v-if="
            item.restoran_delivery_company.length &&
            item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
              .restaurant_id
          "
          v-model="
            item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
              .paying
          "
          hide-details
          class="my-2"
        />
        <text-field class="my-2" v-else hide-details v-model="item.paying" />
      </template>
      <template v-slot:item.internal="{ item }">
        <label
          v-if="
            item.restoran_delivery_company.length &&
            item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
              .restaurant_id
          "
          :for="`internal-${item.id}`"
        >
          <input
            :id="`internal-${item.id}`"
            style="cursor: pointer"
            :value="item.id"
            v-model="
              item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
                .internal
            "
            type="checkbox"
          />
        </label>
        <label v-else :for="`internal-${item.id}`">
          <input
            :id="`internal-${item.id}`"
            style="cursor: pointer"
            :value="item.id"
            v-model="item.internal"
            type="checkbox"
          />
        </label>
      </template>
    </v-data-table>
  </fullscreen-dialog>
</template>

<script>
import FullscreenDialog from "@/components/dialogs/FullscreenDialog.vue";
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";
import restaurantService from "@/services/restaurant";
import companyService from "@/services/company";

export default {
  name: "RestaurantSettingsDialog",
  components: {
    FullscreenDialog,
  },
  mixins: [hasModel, hasSnackbar],
  props: {
    firm: {
      type: Object,
      default: () => ({}),
    },
    countries: {
      type: Array,
      default: () => [],
    },
    cities: {
      type: Array,
      default: () => [],
    },
    editedItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    searchRes: "",
    restaurants: [],
  }),
  computed: {
    headersRes() {
      return [
        {
          text: this.$t("status"),
          align: "center",
          value: "check",
        },
        {
          text: "ID",
          align: "end",
          value: "id",
        },
        {
          text: this.$t("name"),
          align: "start",
          value: "name",
        },
        {
          text: this.$t("status_restoran"),
          align: "start",
          value: "active_restoran",
          sortable: false,
        },
        {
          text: this.$t("status_company"),
          align: "start",
          value: "active_company",
          sortable: false,
        },
        {
          text: this.$t("pay_type"),
          align: "start",
          value: "paying_type",
          sortable: false,
        },
        {
          text: this.$t("amount"),
          align: "start",
          value: "paying",
          sortable: false,
        },
        {
          text: this.$t("internal"),
          align: "start",
          value: "internal",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },

    async save() {
      try {
        let data = {};
        data["restorani"] = this.restaurants;
        data["delivery_company"] = this.firm;
        data["restoran_id"] = this.$store.state.restaurant.id;
        await companyService.storeDeliveryCompanyRestaurants(data);
        this.showSuccessSnackbar(this.$t("firm_settings_saved"));
        this.$emit("saved");
        this.close();
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_saving_firm_settings"));
      }
    },

    onCountryChange() {
      this.$emit("country-change");
    },

    onCityChange() {
      this.loadRestaurantsByCity();
    },

    async loadRestaurantsByCity() {
      try {
        this.restaurants = [];
        const { data } = await restaurantService.getRestaurantsByCity(
          this.editedItem.city
        );
        this.restaurants = data;
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_restaurants"));
      }
    },

    onSelectRestaurant(item) {
      // Handle restaurant selection if needed
      this.$emit("restaurant-selected", item);
    },
  },
};
</script>
